<template>
	<div class="c-controls">
		<div class="c-controls__group">
			<label class="c-controls__label">Storycubes</label>
			<button class="button button--control" v-on:click.prevent="throwDice">Dobbelen</button>
		</div>
	</div>
</template>

<script>
import BaseControl from './BaseControl';

export default {
	name: 'HMWControl',
	mixins: [BaseControl],
	methods: {
		throwDice() {
			this.subcommand('dice.throw');
		},
	},
};
</script>

<style scoped></style>
